'use client'

import Link from 'next/link'
import React from 'react'

interface SignUpCTAProps {
  message: string
  className?: string
}

const AnimatedWhisk: React.FC = () => {
  return (
    <div className="relative flex items-center justify-center">
      <svg
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-bounce"
        style={{ animationDuration: '2s' }}
      >
        {/* Whisk handle */}
        <rect x="10.5" y="2" width="3" height="6" rx="1.5" fill="#85C349" />
        {/* Whisk wires - curved outward */}
        <path
          d="M12 8C12 8 8 10 7 14C6 18 12 22 12 22C12 22 18 18 17 14C16 10 12 8 12 8Z"
          stroke="#85C349"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Additional wires for detail */}
        <path
          d="M12 8L9 12"
          stroke="#85C349"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12 8L15 12"
          stroke="#85C349"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12 8L8 16"
          stroke="#85C349"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12 8L16 16"
          stroke="#85C349"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}

const SignUpCTA: React.FC<SignUpCTAProps> = ({ message, className = '' }) => {
  return (
    <div className={`rounded-2xl bg-gradient-to-br from-[#F3FAEB] to-[#E5F3D4] p-6 sm:p-8 text-center border border-[#8BC34A]/20 shadow-sm ${className}`}>
      <div className="mb-4 flex justify-center">
        <AnimatedWhisk />
      </div>
      <p className="mb-6 text-base sm:text-lg font-medium text-gray-900 leading-relaxed">
        {message}
      </p>
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
        <Link
          href="/auth/join-culineer"
          className="rounded-full bg-[#8BC34A] px-8 py-3 font-semibold text-white transition-all hover:bg-[#7cb342] hover:shadow-md hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#8BC34A] focus:ring-offset-2 active:scale-95"
        >
          Sign up for free
        </Link>
        <Link
          href="/auth/login"
          className="rounded-full border-2 border-[#8BC34A] bg-white px-8 py-3 font-semibold text-[#8BC34A] transition-all hover:bg-[#F3FAEB] hover:shadow-md hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#8BC34A] focus:ring-offset-2 active:scale-95"
        >
          Log in
        </Link>
      </div>
    </div>
  )
}

export default SignUpCTA

